const NothingSelected = () => {
  return (
    <div className="nothing__main-content">
      <p>
        Select Something
        <br></br>
        please create an entry
      </p>

      <i className="far fa-star fa-4x mt-5"></i>
    </div>
  );
};

export default NothingSelected;
